import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader-img',
  templateUrl: './loader-img.component.html',
  styleUrls: ['./loader-img.component.scss'],
  host: { class: 'app-loader-img' }
})
export class LoaderImgComponent implements OnInit {

  @Input('disabled') disabled:boolean
  @Input('big') big:boolean
  @Input('no-bg') noBg:boolean

  constructor() { }

  ngOnInit(): void {
  }

}
